/*
 * @Author: songyzh
 * @Date: 2021-05-12 16:15:54
 * @LastEditors: songyzh
 * @LastEditTime: 2022-04-09 16:35:14
 * @Description:
 */
import { GET } from './base';

export function listWaringMsg() {
  return GET('/warning/list', '获取预警列表');
}

export function newWaringMsg() {
  return GET('/warning/new', '获取预警新消息');
}

export function setWaringState(id) {
  return GET(`/warning/setread?id=${id}`, '设置预警状态');
}

export function listWaringMsg1() {
  return GET('/v1/warning/list', '获取预警列表');
}

export function newWaringMsg1() {
  return GET('/v1/warning/new', '获取预警新消息');
}

export function setWaringState1(id) {
  return GET(`/v1/warning/setread?id=${id}`, '设置预警状态');
}
